import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
// import HomeView from '../views/index.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/map',
    name: 'map',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: "list" */ '../views/index.vue')//(resolve) => require(['../views/index.vue'], resolve)
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "list" */ '../views/login.vue')//(resolve) => require(['../views/login.vue'], resolve)
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
